import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import useTranslation from "@babackapp/translations/use-translation";
import {
  SidebarMenuButton,
  useSidebar,
} from "@babackapp/ui/components/sidebar";
import { PlusCircleIcon } from "lucide-react";

export default function NewReturnButton() {
  const t = useTranslation();
  const { data: shop } = useCurrentShopSuspense();
  const { state } = useSidebar();

  const onClick = () => {
    window.open(`/o?shop=${shop?.shopifyUrl}`);
  };

  if (state === "collapsed") {
    return (
      <SidebarMenuButton
        onClick={onClick}
        className="bg-gradient-to-br font-semibold text-primary-foreground from-indigo-600 to-purple-700 shadow-[0_7px_15px_rgba(137,8,184,0.3)] hover:shadow-[0_7px_15px_rgba(147,22,204,0.5)]"
      >
        <PlusCircleIcon className="size-6" />
      </SidebarMenuButton>
    );
  }

  return (
    <SidebarMenuButton
      onClick={onClick}
      className="bg-gradient-to-br font-semibold text-primary-foreground from-indigo-600 to-purple-700 shadow-[0_7px_15px_rgba(137,8,184,0.3)] hover:shadow-[0_7px_15px_rgba(147,22,204,0.5)] text-center justify-center items-center flex"
    >
      {t("returns.createReturn")}
      <PlusCircleIcon className="size-6" />
    </SidebarMenuButton>
  );
}
